import { BehaviorSubject, Observable} from "rxjs";
import { Injectable} from "@angular/core";
import { OrderListResponse, OrderResponse } from "libs/shared-models/src/lib/order/order-response";

@Injectable({
    providedIn: 'root',
})
export class RestaurantOrdersStateService {

    private state$: BehaviorSubject<OrderResponse[]> = new BehaviorSubject<OrderResponse[]>([]);

    // Used only in the Orders List section
    private currentSelectedOrder$: BehaviorSubject<OrderResponse | null> = new BehaviorSubject<OrderResponse | null>(null);

    constructor(
    ) {
    }

    public getData$(): Observable<OrderResponse[]> {
        return this.state$.asObservable();
    }

    public getData(): OrderResponse[] {
        return this.state$.getValue();
    }

    public setData(value: OrderResponse[]): void {
        this.state$.next(value);
    }

    public getCurrentSelectedOrder(): OrderResponse | null {
        return this.currentSelectedOrder$.getValue();
    }

    public getCurrentSelectedOrder$(): Observable<OrderResponse | null> {
        return this.currentSelectedOrder$.asObservable();
    }

    public setCurrentSelectedOrder(value: OrderResponse | null) {
        return this.currentSelectedOrder$.next(value);
    }


    public updateOrder(updatedOrder: OrderResponse): void {
        if (!this.hasOrder(updatedOrder.id)) {
            // Doesn't exist, don't update
            return;
        }
        const currentOrders = this.getData();
        const updatedOrders = currentOrders.map(order =>
            order.id === updatedOrder.id ? updatedOrder : order
        );
        this.setData(updatedOrders);
    }

    public hasOrder(orderId: string): boolean {
        return this.getData().some(order => order.id === orderId);
    }

    public replaceAndSetCurrentSelectOrder(value: OrderResponse) {
        if (this.hasOrder(value.id)) {
            this.updateOrder(value);
        } else {
            this.setData([value, ...this.getData()]);
        }
        this.setCurrentSelectedOrder(value);
    }
}
